import React, { useCallback, useEffect, useState } from 'react';
import { HiPrinter } from 'react-icons/hi';
import { encode } from 'url-encode-decode';

import { BiCopy, BiTimeFive } from 'react-icons/bi';
import { RiWhatsappLine } from 'react-icons/ri';
import { MdAddShoppingCart, MdRemoveRedEye } from 'react-icons/md';
import { FaWaze } from 'react-icons/fa';
import { Menu, MenuItem } from '@material-ui/core';
import { IoMdSend } from 'react-icons/io';
import CopyToClipboard from 'react-copy-to-clipboard';
import { BsExclamationCircle, BsPhone } from 'react-icons/bs';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';
import CustomPrinter from '../../CustomPrinter';
import { IOrder } from '../../../../interfaces/IOrder';
import * as S from './styles';
import BRLMoneyFormat from '../../../../utils/BRLMoneyFormat';
import Input from '../../../../newComponents/Input';
import { generateMessage } from '../../../../utils/generateMessage';
import { useToast } from '../../../../hooks/toast';
import estagiosPedido from '../../../../utils/estagiosPedido';
import Printer from '../../../../components/Printer';
import { useMonitor } from '../../../../hooks/newMonitor';
import Intership from '../../Internship';
import OrdersService from '../../../../services/OrdersService';
import { useAuth } from '../../../../hooks/auth';
import { IDeliveryAddress } from '../../../../interfaces/IDeliveryAddress';
import { IPaymentMethod } from '../../../../interfaces/IPaymentMethod';
import { IOrderItem } from '../../../../interfaces/IOrderItem';
import { distanceBetweenDatesInFull } from '../../../../utils/DistanceBetweenDatesInFull';
import melhorEnvioService from '../../../../services/melhorEnvio';
import { InsertCartOptionsModal } from './InsertCartOptions';
import Load from '../../../../newComponents/Load';
import { PrintEditedOrder } from './PrintEditedOrder';
import { ConfirmCancelModal } from '../ConfirmCancelModal';
import { EditFractionedItemsModal } from './EditFractionedItems';
import { EmitirNfceModal } from './EmitirNfce';
import { NfceIcon } from './EmitirNfce/NfceIcon';
import { NfceStatusChip } from './EmitirNfce/NfceStatusChip';
import { useSituacaoNfce } from './EmitirNfce/useSituacaoNfce';

interface ContentProps {
  selectedOrderId: number;
  setIsLoadingMain: (value: boolean) => void;
}

export function Content({ selectedOrderId, setIsLoadingMain }: ContentProps) {
  const history = useHistory();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const status = query.get('status');
  const orderId = query.get('orderId');

  const [order, setOrder] = useState<
    | (Partial<IOrder> & {
        deliveryAddress?: Partial<IDeliveryAddress>;
        orderPayment: Partial<IPaymentMethod> & { companyPaymentMethod?: any }; // alterar
        items: Partial<IOrderItem>[];
      })
    | null
  >(null);
  const [phone, setPhone] = useState('');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isLoading, setIsLoading] = useState<'aceitar' | 'cancel' | null>(null);
  const [allTagsCanceled, setAllTagsCanceled] = useState(false);
  const [openInsertCartOptionsModal, setOpenInsertCartOptionsModal] = useState(
    false,
  );
  const [openPrintEditedOrder, setOpenPrintEditedOrder] = useState(false);
  const [isOpenConfirmCancelModal, setIsOpenConfirmCancelModal] = useState(
    false,
  );
  const [
    isOpenEditFractionedItemsModal,
    setIsOpenEditFractionedItemsModal,
  ] = useState(false);
  const [cancelConfirmed, setCancelConfirmed] = useState(false);
  const [isOpenEmitirNfceModal, setIsOpenEmitirNfceModal] = useState(false);

  const { addToast } = useToast();

  const { listOrders, setListOrders, filter, checkEmAguardo } = useMonitor();
  const { user, caixa } = useAuth();

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleChangePhone = (value: string | undefined): void => {
    if (typeof value !== 'string') {
      return;
    }

    if (value.length >= 16) {
      return;
    }

    const maskedValue = value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3');

    setPhone(maskedValue);
  };

  const sendRequest = (): void => {
    if (order && !!phone && phone.length >= 14) {
      const pedidoMessage = generateMessage(order);
      window.open(
        `https://api.whatsapp.com/send?phone=55${phone}&text=${encode(
          pedidoMessage,
        )}.`,
        '_blank',
      );
    } else {
      addToast({
        title: 'Insira um número de telefone.',
        type: 'info',
      });
    }
    setPhone('');
    setAnchorEl(null);
  };

  const redirectToWaze = (): void => {
    if (order && order.deliveryAddress) {
      const linkWaze = `https://waze.com/ul?ll=${order.deliveryAddress.latitude},${order.deliveryAddress.longitude}&z=10`;
      window.open(linkWaze);
    } else {
      addToast({
        title: 'Pedido não possui endereço de  entrega.',
        type: 'info',
      });
    }
  };

  const handleEditOrder = (): void => {
    history.push(`monitor_pedidos/edit/${selectedOrderId}`);
  };

  const loadPedidoData = useCallback(async () => {
    if (!selectedOrderId || !caixa.id || !user.empresa_id) return;

    const response = await OrdersService.showOrder(
      user.empresa_id,
      caixa.id,
      selectedOrderId,
    );

    setOrder(response);
    setIsLoadingMain(false);
  }, [caixa.id, selectedOrderId, user.empresa_id]);

  const handleSetPedidoEmAguardo = async (value: boolean): Promise<void> => {
    if (!order) return;

    try {
      if (value) {
        setIsLoading('aceitar');
        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          selectedOrderId!,
          3,
        );
        addToast({
          title: 'Pedido Aceito',
          type: 'success',
        });
      } else {
        setIsLoading('cancel');
        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          selectedOrderId!,
          2,
        );
        addToast({
          title: 'Pedido Rejeitado',
          type: 'info',
        });
      }

      OrdersService.listOrders(
        user.empresa_id,
        caixa.id,
        listOrders?.currentPage || 1,
        20,
        filter.insternship.join(','),
        filter.text,
      ).then((res) => {
        return setListOrders(res);
      });

      history.push(`/monitor_pedidos?orderId=${order.id}`);
      loadPedidoData();
    } catch (err) {
      const { message } = (err as any).response.data;

      addToast({
        title: 'Erro',
        description: `${message}`,
        type: 'error',
      });
    }
    setIsLoading(null);
  };

  const handleSetPedidoAceito = async (value: boolean): Promise<void> => {
    if (!order) return;

    try {
      if (value) {
        setIsLoading('aceitar');
        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          selectedOrderId!,
          5,
        );

        addToast({
          title: 'Pedido Expedido',
          type: 'success',
        });
      } else {
        setIsLoading('cancel');
        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          selectedOrderId!,
          9,
        );

        addToast({
          title: 'Pedido Cancelado',
          type: 'info',
        });
      }

      OrdersService.listOrders(
        user.empresa_id,
        caixa.id,
        listOrders?.currentPage || 1,
        20,
        filter.insternship.join(','),
        filter.text,
      ).then((res) => {
        return setListOrders(res);
      });

      history.push(`/monitor_pedidos?orderId=${order.id}`);
      loadPedidoData();
    } catch (err) {
      const { message } = (err as any).response.data;

      addToast({
        title: 'Erro',
        description: message,
        type: 'error',
      });
    }
    setIsLoading(null);
  };

  const handleWithdraw = async (value: boolean): Promise<void> => {
    if (!order) return;

    try {
      if (value) {
        setIsLoading('aceitar');
        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          selectedOrderId!,
          11,
        );

        addToast({
          title: 'Pedido pronto para a retirada',
          type: 'success',
        });
      } else {
        setIsLoading('cancel');
        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          selectedOrderId!,
          9,
        );

        addToast({
          title: 'Pedido Cancelado',
          type: 'info',
        });
      }

      OrdersService.listOrders(
        user.empresa_id,
        caixa.id,
        listOrders?.currentPage || 1,
        20,
        filter.insternship.join(','),
        filter.text,
      ).then((res) => {
        return setListOrders(res);
      });

      history.push(`/monitor_pedidos?orderId=${order.id}`);
      loadPedidoData();
    } catch (err) {
      const { message } = (err as any).response.data;

      addToast({
        title: 'Erro',
        description: message,
        type: 'error',
      });
    }
    setIsLoading(null);
  };

  const handleSetPedidoSeparacao = async (value: boolean): Promise<void> => {
    if (!order) return;

    try {
      if (value) {
        setIsLoading('aceitar');
        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          selectedOrderId!,
          12,
        );
        addToast({
          title: 'Pedido em separaçãp',
          type: 'success',
        });
      } else {
        setIsLoading('cancel');
        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          selectedOrderId!,
          2,
        );
        addToast({
          title: 'Pedido Rejeitado',
          type: 'info',
        });
      }

      OrdersService.listOrders(
        user.empresa_id,
        caixa.id,
        listOrders?.currentPage || 1,
        20,
        filter.insternship.join(','),
        filter.text,
      ).then((res) => {
        return setListOrders(res);
      });

      history.push(`/monitor_pedidos?orderId=${order.id}`);
      loadPedidoData();
    } catch (err) {
      const { message } = (err as any).response.data;

      addToast({
        title: 'Erro',
        description: `${message}`,
        type: 'error',
      });
    }
    setIsLoading(null);
  };

  const handleCheckOut = async (value: boolean): Promise<void> => {
    if (!order) return;

    try {
      if (value) {
        setIsLoading('aceitar');
        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          selectedOrderId!,
          6,
        );

        addToast({
          title: 'Pedido Finalizado',
          type: 'success',
        });
      } else {
        setIsLoading('cancel');
        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          selectedOrderId!,
          9,
        );

        addToast({
          title: 'Pedido Cancelado',
          type: 'info',
        });
      }

      OrdersService.listOrders(
        user.empresa_id,
        caixa.id,
        listOrders?.currentPage || 1,
        20,
        filter.insternship.join(','),
        filter.text,
      ).then((res) => {
        return setListOrders(res);
      });

      history.push(`/monitor_pedidos?orderId=${order.id}`);
      loadPedidoData();
    } catch (err) {
      const { message } = (err as any).response.data;

      addToast({
        title: 'Erro',
        description: message,
        type: 'error',
      });
    }
    setIsLoading(null);
  };

  useEffect(() => {
    checkEmAguardo();
  }, [filter.insternship, checkEmAguardo]);

  useEffect(() => {
    if (selectedOrderId) loadPedidoData();
    else if (order) setOrder(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPedidoData, selectedOrderId]);

  useEffect(() => {
    if (order?.tags?.length) {
      const tagsStatus = order.tags.map((tag) => {
        melhorEnvioService
          .findTag(tag.tagId, user.empresa_id)
          .then((res) => {
            return res.status;
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              addToast({
                title: error.response.data.message,
                type: 'error',
              });
            } else {
              addToast({
                title: 'Ocorreu um erro na busca pela etiqueta',
                type: 'error',
              });
            }
          });
        return '';
      });
      setAllTagsCanceled(
        tagsStatus
          .map((status) => status === 'canceled')
          .reduce((prev, next) => prev && next),
      );
    }
  }, [order]);

  useEffect(() => {
    if (order) {
      if (
        status &&
        (status === 'new' || status === 'edited') &&
        order.id?.toString() === orderId
      ) {
        handleOpenPrintEditedOrder();
      }
    }
  }, [order]);

  useEffect(() => {
    if (cancelConfirmed && order) {
      if (
        order.status === estagiosPedido.preparacao &&
        !!order.deliveryAddress
      ) {
        handleSetPedidoAceito(false);
      } else if (
        order.status === estagiosPedido.preparacao &&
        !order.deliveryAddress
      ) {
        handleWithdraw(false);
      } else if (
        order.status === estagiosPedido.rota_entrega ||
        order.status === estagiosPedido.retirada
      ) {
        handleCheckOut(false);
      } else if (
        (order.status === estagiosPedido.aguardo &&
          !order.items.some((item) => item.portioned)) ||
        order.status === estagiosPedido.separacao ||
        (order.status === estagiosPedido.aguardo &&
          order.items.some((item) => item.portioned))
      ) {
        handleSetPedidoEmAguardo(false);
      }
      setCancelConfirmed(false);
    }
  }, [cancelConfirmed]);

  const getCompletedHours = (string: string): string => {
    const newDate = new Date(string);

    return `${(newDate.getHours() < 10 ? '0' : '') + newDate.getHours()}:${
      (newDate.getMinutes() < 10 ? '0' : '') + newDate.getMinutes()
    }`;
  };

  const startConversationOnWhatsapp = (): void => {
    if (order?.customer?.phoneNumber) {
      const msg = encode(
        `Olá, ${
          order.customer.tradingName ?? 'Venda balcão'
        }. Gostariamos de falar sobre o pedido #${order.id}`,
      );
      window.open(
        `https://api.whatsapp.com/send?phone=55${order.customer.phoneNumber}&text=${msg}.`,
        '_blank',
      );
    } else {
      addToast({
        title: 'Cliente não possui número cadastrado.',
        type: 'info',
      });
    }
  };

  const handleOpenInsertCartOptions = (): void => {
    setOpenInsertCartOptionsModal(true);
  };

  const handleCloseInsertCartOptions = (): void => {
    setOpenInsertCartOptionsModal(false);
  };

  const handleOpenPrintEditedOrder = (): void => {
    setOpenPrintEditedOrder(true);
  };

  const handleClosePrintEditedOrder = (): void => {
    setOpenPrintEditedOrder(false);
  };

  function handleOpenConfirmCancelModal() {
    setIsOpenConfirmCancelModal(true);
  }

  const handleCloseConfirmCancelModal = useCallback(() => {
    setIsOpenConfirmCancelModal(false);
  }, []);

  function handleOpenEditFractionedItemsModal() {
    setIsOpenEditFractionedItemsModal(true);
  }

  const handleCloseEditFractionedItemsModal = useCallback(() => {
    setIsOpenEditFractionedItemsModal(false);
  }, []);

  const handleConfirmCancel = useCallback(() => {
    setCancelConfirmed(true);
    handleCloseConfirmCancelModal();
  }, []);

  // NFC-e só para venda: não para pedido aguardando, negado ou cancelado.
  const podeTerNfce =
    order?.status !== undefined &&
    ![
      estagiosPedido.aguardo,
      estagiosPedido.negado,
      estagiosPedido.cancelado,
      estagiosPedido.cancelado_cliente,
    ].includes(order.status);

  const nfce = useSituacaoNfce(order?.id, podeTerNfce);

  return order ? (
    <S.ContainerInfo>
      <div className="header">
        <div className="header__title">
          <div>
            <h1>
              Pedido <span>{`#${order.id}`}</span>
            </h1>
            {podeTerNfce && (
              <NfceStatusChip
                situacao={nfce.situacao}
                onClick={() => setIsOpenEmitirNfceModal(true)}
              />
            )}
            <div className="header__title__functions a1">
              <CustomPrinter pedido={order}>
                <HiPrinter size={20} />
              </CustomPrinter>
              <button
                type="button"
                title="Imprimir edição do pedido"
                data-tooltip="Imprimir edição do pedido"
                id="basic-button"
                onClick={handleOpenPrintEditedOrder}
                style={{
                  background: '#f57c00',
                }}
              >
                <HiPrinter size={20} />
              </button>
              {podeTerNfce && (
                <button
                  type="button"
                  title="Emitir NFC-e"
                  data-tooltip="Emitir NFC-e"
                  onClick={() => setIsOpenEmitirNfceModal(true)}
                >
                  <NfceIcon size={16} />
                </button>
              )}
              {generateMessage(order) && (
                <CopyToClipboard
                  text={`${generateMessage(order)}`}
                  onCopy={() => {
                    addToast({
                      title: 'Pedido copiado.',
                      type: 'success',
                    });
                  }}
                >
                  <div>
                    <BiCopy size={20} />
                  </div>
                </CopyToClipboard>
              )}
              <button
                type="button"
                data-tooltip="Enviar pedido pelo whatsapp"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                <RiWhatsappLine size={20} />
              </button>
              {((order.logisticDeliveryId &&
                !(order.tags && order.tags.length > 0) &&
                order.status !== 0 &&
                order.status !== 2 &&
                order.status !== 9) ||
                allTagsCanceled) && (
                <button
                  type="button"
                  data-tooltip="Adicionar ao carrinho do melhor envio"
                  title="Adicionar ao carrinho do melhor envio"
                  id="basic-button"
                  onClick={handleOpenInsertCartOptions}
                >
                  <MdAddShoppingCart size={20} />
                </button>
              )}

              {order.logisticDeliveryId &&
                order.tags &&
                order.tags.length > 0 &&
                !allTagsCanceled && (
                  <button
                    type="button"
                    data-tooltip="Ir para página de etiquetas"
                    title="Ir para página de etiquetas"
                    id="basic-button"
                    onClick={() => history.push(`etiquetas/${order.id}`)}
                  >
                    <MdRemoveRedEye size={20} />
                  </button>
                )}
            </div>
          </div>

          <p>
            {`Criado ${distanceBetweenDatesInFull(
              order.createdAt!,
            )}, às ${getCompletedHours(order.createdAt!)} por ${
              order.customer?.tradingName ?? 'Venda balcão'
            }`}
          </p>

          <div className="header__title__functions a2">
            <CustomPrinter pedido={order}>
              <HiPrinter size={20} />
              <p>Imprimir</p>
            </CustomPrinter>
            <button
              type="button"
              title="Imprimir edição do pedido"
              data-tooltip="Imprimir edição do pedido"
              id="basic-button"
              onClick={handleOpenPrintEditedOrder}
            >
              <HiPrinter size={20} />
              <p>Imprimir - Produção</p>
            </button>
            {podeTerNfce && (
              <button
                type="button"
                title="Emitir NFC-e"
                onClick={() => setIsOpenEmitirNfceModal(true)}
              >
                <NfceIcon size={16} />
                <p>Nota fiscal</p>
              </button>
            )}
          </div>

          <div className="header__title__functions a2">
            {generateMessage(order) && (
              <CopyToClipboard
                text={`${generateMessage(order)}`}
                onCopy={() => {
                  addToast({
                    title: 'Pedido copiado.',
                    type: 'success',
                  });
                }}
              >
                <div>
                  <BiCopy size={20} />
                  <p>Copiar</p>
                </div>
              </CopyToClipboard>
            )}
            <button type="button" id="basic-button" onClick={handleClick}>
              <RiWhatsappLine size={20} />
              <p>Compartilhar</p>
            </button>
            {((order.logisticDeliveryId &&
              !(order.tags && order.tags.length > 0) &&
              order.status !== 0 &&
              order.status !== 2 &&
              order.status !== 9) ||
              allTagsCanceled) && (
              <button
                type="button"
                data-tooltip="Adicionar ao carrinho do melhor envio"
                title="Adicionar ao carrinho do melhor envio"
                id="basic-button"
                onClick={handleOpenInsertCartOptions}
              >
                <MdAddShoppingCart size={20} />
                <p>Adicionar no carrinho</p>
              </button>
            )}

            {order.logisticDeliveryId &&
              order.tags &&
              order.tags.length > 0 &&
              !allTagsCanceled && (
                <button
                  type="button"
                  data-tooltip="Ir para página de etiquetas"
                  title="Ir para página de etiquetas"
                  id="basic-button"
                  onClick={() => history.push(`etiquetas/${order.id}`)}
                >
                  <MdRemoveRedEye size={20} />
                  <p>Visualizar etiqueta</p>
                </button>
              )}
          </div>
        </div>

        <div className="header__buttons">
          {order.status === estagiosPedido.aguardo &&
            !order.items.some((item) => item.portioned) && (
              <>
                <Printer
                  className="confirm-btn"
                  backgroundColor="#00c853"
                  textColor="#fff"
                  disabled={!!isLoading}
                  pedido={order}
                  label="Confirmar"
                  id="printer_btn"
                  onClick={() => handleSetPedidoEmAguardo(true)}
                />
                <button
                  disabled={!!isLoading}
                  type="button"
                  onClick={handleOpenConfirmCancelModal}
                >
                  {isLoading === 'cancel' ? (
                    <div className="loader" />
                  ) : (
                    'Rejeitar'
                  )}
                </button>
                {!order.logisticDeliveryId && (
                  <button
                    disabled={!!isLoading}
                    type="button"
                    onClick={handleEditOrder}
                  >
                    {isLoading === 'cancel' ? (
                      <div className="loader" />
                    ) : (
                      'Editar'
                    )}
                  </button>
                )}
              </>
            )}

          {order.status === estagiosPedido.separacao && (
            <>
              <Printer
                className="confirm-btn"
                backgroundColor="#00c853"
                textColor="#fff"
                disabled={!!isLoading}
                pedido={order}
                label="Preparar"
                id="printer_btn"
                onClick={() => handleSetPedidoEmAguardo(true)}
              />
              <button
                disabled={!!isLoading}
                type="button"
                onClick={handleOpenConfirmCancelModal}
              >
                {isLoading === 'cancel' ? (
                  <div className="loader" />
                ) : (
                  'Rejeitar'
                )}
              </button>
              {!order.logisticDeliveryId && (
                <button
                  disabled={!!isLoading}
                  type="button"
                  onClick={handleEditOrder}
                >
                  {isLoading === 'cancel' ? (
                    <div className="loader" />
                  ) : (
                    'Editar'
                  )}
                </button>
              )}
            </>
          )}

          {order.status === estagiosPedido.aguardo &&
            order.items.some((item) => item.portioned) && (
              <>
                <Printer
                  className="confirm-btn"
                  backgroundColor="#00c853"
                  textColor="#fff"
                  disabled={!!isLoading}
                  pedido={order}
                  label="Confirmar"
                  id="printer_btn"
                  onClick={() => handleSetPedidoSeparacao(true)}
                />
                <button
                  disabled={!!isLoading}
                  type="button"
                  onClick={handleOpenConfirmCancelModal}
                >
                  {isLoading === 'cancel' ? (
                    <div className="loader" />
                  ) : (
                    'Rejeitar'
                  )}
                </button>
                {!order.logisticDeliveryId && (
                  <button
                    disabled={!!isLoading}
                    type="button"
                    onClick={handleEditOrder}
                  >
                    {isLoading === 'cancel' ? (
                      <div className="loader" />
                    ) : (
                      'Editar'
                    )}
                  </button>
                )}
              </>
            )}

          {order.status === estagiosPedido.preparacao &&
            !!order.deliveryAddress && (
              <>
                <button
                  disabled={!!isLoading}
                  type="button"
                  onClick={() => handleSetPedidoAceito(true)}
                >
                  {isLoading === 'aceitar' ? (
                    <div className="loader" />
                  ) : (
                    'Expedir'
                  )}
                </button>
                <button
                  disabled={!!isLoading}
                  type="button"
                  onClick={handleOpenConfirmCancelModal}
                >
                  {isLoading === 'cancel' ? (
                    <div className="loader" />
                  ) : (
                    'Cancelar'
                  )}
                </button>
                {!order.logisticDeliveryId && (
                  <button
                    disabled={!!isLoading}
                    type="button"
                    onClick={handleEditOrder}
                  >
                    {isLoading === 'cancel' ? (
                      <div className="loader" />
                    ) : (
                      'Editar'
                    )}
                  </button>
                )}
              </>
            )}

          {order.status === estagiosPedido.preparacao &&
            !order.deliveryAddress && (
              <>
                <button
                  disabled={!!isLoading}
                  type="button"
                  onClick={() => handleWithdraw(true)}
                >
                  {isLoading === 'aceitar' ? (
                    <div className="loader" />
                  ) : (
                    'Pronto retirada'
                  )}
                </button>
                <button
                  disabled={!!isLoading}
                  type="button"
                  onClick={handleOpenConfirmCancelModal}
                >
                  {isLoading === 'cancel' ? (
                    <div className="loader" />
                  ) : (
                    'Cancelar'
                  )}
                </button>
                {!order.logisticDeliveryId && (
                  <button
                    disabled={!!isLoading}
                    type="button"
                    onClick={handleEditOrder}
                  >
                    {isLoading === 'cancel' ? (
                      <div className="loader" />
                    ) : (
                      'Editar'
                    )}
                  </button>
                )}
              </>
            )}

          {(order.status === estagiosPedido.rota_entrega ||
            order.status === estagiosPedido.retirada) && (
            <>
              <button
                disabled={!!isLoading}
                type="button"
                onClick={() => handleCheckOut(true)}
              >
                {isLoading === 'aceitar' ? (
                  <div className="loader" />
                ) : (
                  'Finalizar'
                )}
              </button>
              <button
                disabled={!!isLoading}
                type="button"
                onClick={handleOpenConfirmCancelModal}
              >
                {isLoading === 'cancel' ? (
                  <div className="loader" />
                ) : (
                  'Cancelar'
                )}
              </button>
            </>
          )}
        </div>
      </div>

      <S.Section>
        <div className="section__header">
          <h2>Acompanhe o pedido</h2>
        </div>

        <div className="section__content">
          <Intership estagio={order.status!} order={order} />
        </div>
      </S.Section>

      {order.scheduledDeliveryAt ? (
        <S.Section className="programada">
          <BiTimeFive size={20} />
          <h2>
            Entrega programada para:{' '}
            <span>
              {moment(new Date(order.scheduledDeliveryAt)).format('LLLL')}
            </span>
          </h2>
        </S.Section>
      ) : null}

      {!order.deliveryAddress ? (
        <S.Section className="retirada">
          <BsExclamationCircle size={20} />
          <h2>Retirada balcão</h2>
        </S.Section>
      ) : null}

      <div className="order__info">
        <S.Section>
          <div className="section__header">
            <h2>Cliente</h2>
            {order.customer && (
              <>
                <button
                  type="button"
                  className="section__header__icon whatsapp"
                  data-tooltip="Iniciar conversa com cliente"
                  id="basic-button"
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={startConversationOnWhatsapp}
                >
                  <RiWhatsappLine size={16} />
                </button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <MenuItem>
                    <div
                      style={{
                        display: 'flex',
                        gap: '4px',
                        alignItems: 'center',
                      }}
                    >
                      <Input
                        icon={BsPhone}
                        placeholder="DDD + número"
                        value={phone}
                        onChange={(event) =>
                          handleChangePhone(event.target.value)
                        }
                      />
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                        onClick={sendRequest}
                      >
                        <IoMdSend size={28} color="#329bfc" />
                      </div>
                    </div>
                  </MenuItem>
                </Menu>
              </>
            )}
          </div>

          <div className="section__info">
            <div>
              <p>Nome</p>
              <p>
                {order.customer ? order.customer?.tradingName : 'Venda balcão'}
              </p>
            </div>
            {order.customer && (
              <div>
                <p>Telefone</p>
                <p>{order.customer?.phoneNumber}</p>
              </div>
            )}
          </div>
        </S.Section>

        <S.Section>
          <div className="section__header">
            <h2>Pagamento</h2>
          </div>

          <div className="section__info">
            <div>
              <p>Forma</p>
              <p>
                {
                  order.orderPayment.companyPaymentMethod?.paymentMethod
                    .description
                }
              </p>
            </div>
            <div>
              {order.orderPayment.companyPaymentMethod?.paymentMethod
                .description === 'Dinheiro' ? (
                <>
                  <p>Troco</p>
                  <p>
                    {Number(order.changeFor).toLocaleString(
                      'pt-BR',
                      BRLMoneyFormat,
                    )}
                  </p>
                </>
              ) : (
                <>
                  <p>Tipo</p>
                  <p>Pagamento na entrega</p>
                </>
              )}
            </div>
          </div>
        </S.Section>

        {order.observation && (
          <S.Section>
            <div className="section__header">
              <h2>Observações</h2>
            </div>

            <div className="section__info">
              <div>
                <p>{order.observation}</p>
              </div>
            </div>
          </S.Section>
        )}

        {order.orderPromotion && order.orderPromotion.length > 0 && (
          <S.Section>
            <div className="section__header">
              <h2>Promoções</h2>
            </div>

            <div className="section__info">
              {order.orderPromotion.map((promo) => (
                <div>
                  <p>{promo.promotion.name}</p>
                  <p>
                    {Number(promo.value).toLocaleString(
                      'pt-BR',
                      BRLMoneyFormat,
                    )}
                  </p>
                </div>
              ))}
            </div>
          </S.Section>
        )}
      </div>

      {order.logisticDelivery && (
        <S.Section>
          <div className="section__header">
            <h2>Detalhes do frete</h2>
          </div>

          <div className="section__info">
            <div>
              <p>Transportadora</p>
              <p>{order.logisticDelivery.nome_transportadora}</p>
            </div>
            <div>
              <p>Serviço</p>
              <p>{order.logisticDelivery.nome_servico_transportadora}</p>
            </div>
            {order.tags && order.tags.findIndex((tag) => !!tag.tracking) >= 0 && (
              <div>
                <p>Rastreio</p>
                <p>{order.tags.map((tag) => tag.tracking).join(', ')}</p>
              </div>
            )}
            <div>
              <p>Valor</p>
              <p>
                {Number(order.logisticDelivery.preco_custom).toLocaleString(
                  'pt-BR',
                  BRLMoneyFormat,
                )}
              </p>
            </div>
            <div>
              <p>Previsão de entrega</p>
              <p>{order.logisticDelivery.estimativa_tempo_entrega} dias</p>
            </div>
          </div>
        </S.Section>
      )}

      {order.deliveryAddress && (
        <div className="address">
          <S.Section>
            <div className="section__header">
              <h2>Endereço</h2>
            </div>

            <div className="section__info">
              <div>
                <p>Logradouro</p>
                <p>{order.deliveryAddress.address.logradouro}</p>
              </div>
              <div>
                <p>Bairro</p>
                <p>{order.deliveryAddress.address.bairro}</p>
              </div>
              <div>
                <p>Estado</p>
                <p>{order.deliveryAddress.address.estado}</p>
              </div>
              <div>
                <p>Cidade</p>
                <p>{order.deliveryAddress.address.cidade}</p>
              </div>
              <div>
                <p>Número</p>
                <p>{order.deliveryAddress.address.numero}</p>
              </div>
              <div>
                <p>Complemento</p>
                <p>{order.deliveryAddress.address.complemento}</p>
              </div>
            </div>
          </S.Section>
          <S.Section>
            <div className="section__header">
              <h2>Rota de Entrega</h2>
              <div
                className="section__header__icon waze"
                data-tooltip="Abrir link do waze"
                onClick={redirectToWaze}
              >
                <FaWaze size={16} />
              </div>
            </div>

            <iframe
              title="waze"
              src={`https://embed.waze.com/iframe?zoom=6&lat=${order.deliveryAddress.latitude}lon=${order.deliveryAddress.longitude}&pin=1`}
              width="300"
              height="400"
            />
          </S.Section>
        </div>
      )}

      <S.Section>
        <div className="section__header">
          <h2>Itens do pedido</h2>

          {order.status === estagiosPedido.separacao && (
            <button
              type="button"
              onClick={handleOpenEditFractionedItemsModal}
              className="editQuantities"
            >
              {isLoading === 'cancel' ? (
                <div className="loader" />
              ) : (
                'Editar Quantidades'
              )}
            </button>
          )}
        </div>
        <div className="section__itens">
          {order.items.map((item: IOrderItem, index: number, array: any[]) => (
            <React.Fragment key={item.id}>
              <div className="order__item">
                <div className="order__item__description">
                  <span>
                    {item.portioned
                      ? `${
                          item.quantity >= 1
                            ? Number(item.quantity).toFixed(3)
                            : item.quantity *
                              item.measurementUnit[0].quantityPortion
                        }${
                          item.quantity >= 1
                            ? item.measurementUnit[0].acronym
                            : item.measurementUnit[0].acronymPortion
                        }`
                      : Number(item.quantity)}
                  </span>
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {!item.colorName && item.sizeName ? (
                    <p>Pizza {String(item.sizeName).toLowerCase()}</p>
                  ) : item.colorName ? (
                    <div>
                      <p>{item.productName}</p>
                      <p>
                        {item.productGridName}
                        {item.colorName && ` - ${item.colorName}`}
                      </p>
                    </div>
                  ) : (
                    <p>
                      {item.productName}
                      {item.portioned &&
                        order.status === estagiosPedido.separacao && (
                          <span className="sort"> - Separar</span>
                        )}
                    </p>
                  )}
                  <p>
                    (
                    {Number(item.productPrice).toLocaleString(
                      'pt-BR',
                      BRLMoneyFormat,
                    )}
                    )
                  </p>
                </div>

                {!(!item.colorName && item.sizeName) && (
                  <p>
                    {Number(item.totalPrice).toLocaleString(
                      'pt-BR',
                      BRLMoneyFormat,
                    )}
                  </p>
                )}
              </div>

              {!!item.observation && (
                <div className="note">
                  <p>Observação:</p>
                  <p>{item.observation}</p>
                </div>
              )}

              {item.childOrderItems?.map((complemento: IOrderItem) => (
                <div className="order__item__complement" key={complemento.id}>
                  <div>
                    <p>{Number(complemento.quantity)}</p>
                    <p>{complemento.productName}</p>
                  </div>
                  <hr />
                  <p>
                    {Number(complemento.totalPrice).toLocaleString(
                      'pt-BR',
                      BRLMoneyFormat,
                    )}
                  </p>
                </div>
              ))}

              {index < array.length - 1 && <S.DashedDivider />}
            </React.Fragment>
          ))}
        </div>

        <div className="section__total">
          <div>
            <p>Total dos itens:</p>
            <p>
              {Number(order.itemsTotalPrice).toLocaleString(
                'pt-BR',
                BRLMoneyFormat,
              )}
            </p>
          </div>
          {order.deliveryAddress && (
            <div>
              <p>Taxa de entrega:</p>
              <p>
                {Number(order.deliveryFee).toLocaleString(
                  'pt-BR',
                  BRLMoneyFormat,
                )}
              </p>
            </div>
          )}
          {order.orderPromotion && order.orderPromotion.length > 0 && (
            <div>
              <p>Desconto na taxa de entrega</p>
              <p>
                -{' '}
                {Number(
                  order.orderPromotion
                    .map((oPromo) => Number(oPromo.value))
                    .reduce((prev, next) => prev + next),
                ).toLocaleString('pt-BR', BRLMoneyFormat)}
              </p>
            </div>
          )}
          {order.discountCouponValue && Number(order.discountCouponValue) > 0 && (
            <div>
              <p>Cupom de desconto ({order.discountCoupon?.code}):</p>
              <p>
                -{' '}
                {Number(order.discountCouponValue).toLocaleString(
                  'pt-BR',
                  BRLMoneyFormat,
                )}
              </p>
            </div>
          )}
          {order.othersDiscountsValue &&
            Number(order.othersDiscountsValue) > 0 && (
              <div>
                <p>Outros descontos:</p>
                <p>
                  -{' '}
                  {Number(order.othersDiscountsValue).toLocaleString(
                    'pt-BR',
                    BRLMoneyFormat,
                  )}
                </p>
              </div>
            )}
          <div>
            <p>Valor total:</p>
            <p>{Number(order.total).toLocaleString('pt-BR', BRLMoneyFormat)}</p>
          </div>
        </div>
      </S.Section>

      {openInsertCartOptionsModal && order && order.id && (
        <InsertCartOptionsModal
          companyId={user.empresa_id}
          loadPedidoData={loadPedidoData}
          handleClose={handleCloseInsertCartOptions}
          open={openInsertCartOptionsModal}
          order={order}
        />
      )}

      {openPrintEditedOrder && order && (
        <PrintEditedOrder
          handleClose={handleClosePrintEditedOrder}
          open={openPrintEditedOrder}
          items={order.items}
          order={order}
        />
      )}

      {isOpenConfirmCancelModal && (
        <ConfirmCancelModal
          isOpen={isOpenConfirmCancelModal}
          handleClose={handleCloseConfirmCancelModal}
          handleCancel={handleConfirmCancel}
        />
      )}
      {isOpenEditFractionedItemsModal && (
        <EditFractionedItemsModal
          loadPedidoData={loadPedidoData}
          handleClose={handleCloseEditFractionedItemsModal}
          open={isOpenEditFractionedItemsModal}
          order={order}
        />
      )}
      {isOpenEmitirNfceModal && order.id && (
        <EmitirNfceModal
          open={isOpenEmitirNfceModal}
          pedidoId={order.id}
          handleClose={() => setIsOpenEmitirNfceModal(false)}
          situacao={nfce.situacao}
          carregando={nfce.carregando}
          recarregar={nfce.recarregar}
          setSituacao={nfce.setSituacao}
        />
      )}
    </S.ContainerInfo>
  ) : (
    <div
      style={{
        display: 'flex',
        flex: '1',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Load />
    </div>
  );
}
